import { FormattedInput } from '@payments-checkout/shared/components';
import { findDesiredCountry } from '@payments-checkout/shared/helpers/translations/internacional-address.helpers';
import { Select } from '@stone-payments/jade';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { usePageSharedData } from '../../../hooks/usePageSharedData';

type CountryInputProps = {
  isError: boolean;
  isCountriesLoading: boolean;
  countries?: Array<{ name: string; code: string }>;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const CountryInput = ({
  isError,
  isCountriesLoading,
  countries,
  onChange
}: CountryInputProps) => {
  const { formatMessage } = useIntl();
  const { paymentLinkIdData } = usePageSharedData();
  const country =
    paymentLinkIdData.data?.customer_settings?.customer?.address?.country;

  const {
    setValue,
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  useEffect(() => {
    const desiredCountry = findDesiredCountry(countries, country);

    setValue('billing-address-country', desiredCountry.code);
  }, [countries]);

  const countriesOptions = useMemo(() => {
    return (
      countries?.map((item) => {
        return { label: item.name, value: item.code };
      }) || [
        {
          label: formatMessage({ id: 'addressFields.value.Brazil' }),
          value: 'BR',
        },
      ]
    );
  }, [countries]);

  if (isError) {
    return (
      <FormattedInput
        formatter="brazilianStates"
        label={formatMessage({ id: 'addressField.country' })}
        error={!!errors['billing-address-country']?.message}
        size="medium"
        placeholder="PR"
        onFocus={() => {
          clearErrors('billing-address-country');
        }}
        {...register('billing-address-country', { required: true })}
      />
    );
  }

  return (
    <Select
      data-testid="billing-address-country"
      size="medium"
      disabled={isCountriesLoading}
      label={formatMessage({ id: 'addressField.country' })}
      options={countriesOptions}
      {...register('billing-address-country')}
      onChange={onChange}
    />
  );
};

export { CountryInput };
